// extracted by mini-css-extract-plugin
export default {"dataTable":"ImmunizationHistory_dataTable__l6aOX","innerTable":"ImmunizationHistory_innerTable__Ruvjb"};